/**
 * F-008 — LoadingSpinner primitive.
 *
 * Small inline spinner for buttons / inline-busy states. Pure CSS
 * (no SVG, no dependency). The container fragment is purposefully
 * empty of text so the parent can place it next to a label.
 *
 * Use `<Skeleton>` for area-busy states (lists, detail panes); use
 * this spinner for "this single action is in flight".
 */
interface LoadingSpinnerProps {
  /** Optional label read by screen readers (defaults to "Loading"). */
  label?: string;
  /** Whether to render inline (default) or as a centered block. */
  inline?: boolean;
  className?: string;
}

export default function LoadingSpinner({ label = 'Loading', inline = true, className }: LoadingSpinnerProps) {
  const cls = `loading-spinner${inline ? ' loading-spinner--inline' : ''}${className ? ` ${className}` : ''}`;
  return (
    <span className={cls} role="status" aria-live="polite" data-testid="loading-spinner">
      <span className="loading-spinner__circle" aria-hidden="true" />
      <span className="sr-only">{label}</span>
    </span>
  );
}
